module.exports = __webpack_public_path__ + "static/fonts/PorscheNext-ThinItalic.f11792c1.otf";